import React from 'react'
import { styled } from 'inlines'

export const OnceLogo = () => {
  return (
    <styled.svg
      width="44"
      height="12"
      viewBox="0 0 44 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2527 5.95488C11.2527 9.45984 9.04402 11.9098 5.61817 11.9098C2.19231 11.9098 0 9.45984 0 5.95488C0 2.44992 2.19231 0 5.61817 0C9.04402 0 11.2527 2.44992 11.2527 5.95488ZM2.28934 5.95584C2.28934 8.32416 3.50751 10.0118 5.61817 10.0118V10.0099C7.74515 10.0099 8.96332 8.32224 8.96332 5.95392C8.96332 3.5856 7.72882 1.89792 5.61817 1.89792C3.50751 1.89792 2.28934 3.58752 2.28934 5.95584ZM14.5065 2.115H16.4279V9.79498H18.3493V11.715H22.3843V0.195L20.2707 0.19788V9.79498H18.3493V2.115H16.4279V0.195H14.4268L12.393 0.19788V11.715H14.5065V2.115ZM37.6421 6.64992V9.81408H43.9414V11.712H35.4008V0.192H43.8607V2.08992H37.6421V4.91424H43.2439V6.64992H37.6421ZM34.3603 7.5168C33.8617 10.1683 32.0383 11.9146 29.1457 11.9146C25.7179 11.9146 23.6332 9.46368 23.6332 5.95776C23.6332 2.45184 25.716 0 29.1438 0C32.0527 0 33.8819 1.7664 34.368 4.44384H32.0662C31.7213 2.90016 30.7827 1.89888 29.1438 1.89888C27.0158 1.89888 25.9235 3.58752 25.9235 5.9568C25.9235 8.32608 27.0341 10.0147 29.1457 10.0147C30.7558 10.0147 31.6973 9.03264 32.0547 7.51584H34.3613L34.3603 7.5168Z"
        fill="white"
      />
    </styled.svg>
  )
}
